import React, { useRef, lazy, Suspense, useCallback } from 'react';
import { string, arrayOf, func, shape, number, bool } from 'prop-types';
import { contextPropTypes } from '../../../proptypes/shared';
import styles from './styles/styles.module.scss';
import MagGlassIcon from '../../svg/search/MagGlassIcon';
import GoArrow from '../../../../assets/images/icons/search/go-arrow.svg';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import SearchInput from '../SearchInput';

const SearchResultsDropdown = lazy(() => import('../SearchResultsDropdown'));

const SearchBar = ({
  query,
  updateQuery,
  placeholderText,
  results,
  filters,
  activeFilterIndex,
  updateActiveTabFilter,
  toggleEngaged,
  engaged,
  context,
  activeIndexResult,
  updateActiveIndexResult,
  handleSearchResultClick,
  mobileSearchBar
}) => {
  const inputRef = useRef();

  const handleSubmit = e => {
    e.preventDefault();

    const submittedResult = results[activeIndexResult];
    if (submittedResult) {
      handleSearchResultClick(submittedResult, activeIndexResult);
    }
  };

  const handleBackgroundClick = useCallback(() => {
    toggleEngaged(false);
  }, []);

  return (
    <>
      <div id="searchBar" className={styles.container}>
        <form className={styles.form} onSubmit={handleSubmit}>
          <MagGlassIcon />
          <SearchInput
            inputRef={inputRef}
            query={query}
            handleExit={() => toggleEngaged(false)}
            onFocus={() => toggleEngaged(true)}
            updateQuery={updateQuery}
            className={styles.searchInput}
            placeholderText={placeholderText}
            readOnly={context.mobileBrowser} // using readOnly here for focus management for the MobileSearchBar component on IOS
          />
          <button type="submit" className={styles.submitBtn} data-test-id="algoliaSearchButton">
            <img src={GoArrow} alt="icon" />
          </button>
        </form>
        {engaged && !mobileSearchBar && (
          <Suspense fallback={null}>
            <div className={styles.dropdownContainer}>
              <div className={styles.offsetSpacer} />
              <SearchResultsDropdown
                results={results}
                filters={filters}
                activeFilterIndex={activeFilterIndex}
                updateActiveTabFilter={updateActiveTabFilter}
                query={query}
                languageRegionCode={context.languageRegionCode}
                activeIndexResult={activeIndexResult}
                handleSearchResultClick={handleSearchResultClick}
                updateActiveIndexResult={updateActiveIndexResult}
              />
            </div>
          </Suspense>
        )}
      </div>
      {engaged && <div className={styles.searchBackground} onClick={handleBackgroundClick} />}
    </>
  );
};

SearchBar.propTypes = {
  placeholderText: string,
  query: string,
  updateQuery: func.isRequired,
  results: arrayOf(
    shape({
      name: string,
      location: string,
      objectID: string,
      url: string,
      type: string
    })
  ),
  filters: arrayOf(shape({ key: string, label: string })),
  activeFilterIndex: number,
  updateActiveTabFilter: func,
  toggleEngaged: func,
  engaged: bool,
  context: contextPropTypes.isRequired,
  activeIndexResult: number,
  updateActiveIndexResult: func,
  handleSearchResultClick: func,
  mobileSearchBar: bool
};

SearchBar.defaultProps = {
  placeholderText: StringConstantsMixin.strings.SEARCH.SEARCH_DEFAULT_PLACEHOLDER,
  query: '',
  results: [],
  filters: null,
  activeFilterIndex: null,
  updateActiveTabFilter: () => {},
  toggleEngaged: () => {},
  engaged: false,
  activeIndexResult: 0,
  updateActiveIndexResult: () => {},
  handleSearchResultClick: () => {},
  mobileSearchBar: false
};

export default SearchBar;
